import React from "react";
import { useSelector } from "react-redux";
import Product from "../Product";


const Section = ({name, description, content, classe, textClass, sectionClass}) => {
    const sections = useSelector((state) => state.step.sections);

    const toUpper = (sectionName) => {
        let newSectionName = sectionName.toUpperCase()
    
        return newSectionName
      }
  
    return (
      <>
        <div className={classe}>
            <div className={classe}>
                <div className={classe}>
                    <div className="mb-3">
                        <div className={sectionClass}>
                            <span className={textClass}>{name}</span>
                        </div>
                    </div>
                    <p className="mb-4">{description}</p>
                    <div className="container py-5">
                        <div className="row">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
  };
  

export default Section